var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOnlineCourseSmall(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Component_59_1",
    "data-name": "Component 59 \\u2013 1",
    transform: "translate(-8, -8)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13549",
    "data-name": "Path 13549",
    d: "M13.915,22.18l12.645-6.9a3.06,3.06,0,0,1,2.88,0l14.28,7.785a1.508,1.508,0,0,1,.78,1.32V34a1.5,1.5,0,0,1-3,0V25.135L29.44,31.72a2.978,2.978,0,0,1-2.88,0l-12.645-6.9A1.51,1.51,0,0,1,13.915,22.18ZM17.5,33.985V29.77l9.06,4.95a2.978,2.978,0,0,0,2.88,0l9.06-4.95v4.215a3.017,3.017,0,0,1-1.56,2.64l-7.5,4.095a2.978,2.978,0,0,1-2.88,0l-7.5-4.095A3.017,3.017,0,0,1,17.5,33.985Z",
    transform: "translate(-0.5 -0.5)",
    fill: "#751056",
    fillRule: "evenodd"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOnlineCourseSmall);
export default __webpack_public_path__ + "static/media/online-course-small.9eeb4f756964bece5101026e370f60df.svg";
export { ForwardRef as ReactComponent };